import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { RolAux, User } from '../model/authentication.model';
import { TokenStorageService } from '../authentication/token-storage.service';
import { NavigationHistoryService } from '../service/navigation-history.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {

  constructor(
    private router: Router,
    private tokenStorageService: TokenStorageService,
    private navigationHistoryService: NavigationHistoryService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedRoles: string[] = route.data?.roles;

    if (!allowedRoles || allowedRoles.length === 0) {
      return true;
    }

    const user: User = this.tokenStorageService.getUser();
    const userRoles = (user.roles || []).map((rol: RolAux) => rol.name);

    if (userRoles.some(role => allowedRoles.includes(role))) {
      return true;
    }

    this.router.navigate(['/404'], { queryParams: { from: this.navigationHistoryService.currentUrl } });
    return false;
  }
}
